import type { DevScenario } from '@arya/shared/domain';
import type { MockApiErrorBody } from '@arya/shared/msw-cloudflare';
import { devScenarioRequest } from '@arya/shared/msw-cloudflare';

import { http, HttpResponse } from 'msw';

export const INVEST_INSUFFICIENT_FUNDS_SCENARIO: DevScenario = {
  name: 'invest-422',
  group: 'Invest',
  title: 'Insufficient funds',
  description: 'Confirming an investment answers 422: the dialog asks for a deposit.',
  screen: '/market/projects/2?invest=2500',
};

export const investInsufficientFundsHandler = http.all(
  devScenarioRequest(
    { method: 'POST', path: '/api/market/projects/:projectId/invest' },
    INVEST_INSUFFICIENT_FUNDS_SCENARIO
  ),
  () => {
    const body: MockApiErrorBody = { error: { message: 'Insufficient funds' } };
    return HttpResponse.json(body, { status: 422 });
  }
);
